(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 1. QUICK ADD from any product card */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-qa-v]'); if (!b || b.disabled) return;
    e.preventDefault(); b.classList.add('is-busy');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-qa-v'), 10), quantity: 1 }] }) })
      .then(function(r){ return r.json(); })
      .then(function(){ b.classList.remove('is-busy'); b.classList.add('is-added'); setTimeout(function(){ b.classList.remove('is-added'); }, 1600);
        var opener = document.querySelector('[data-open-cart]'); if (opener) opener.click(); })
      .catch(function(){ b.classList.remove('is-busy'); });
  });

  /* 2. Sticky bar shows the chosen size */
  var sticky = document.querySelector('.sticky-atc__t small');
  if (sticky) {
    var tag = document.createElement('span'); tag.className = 'sticky-atc__size'; sticky.appendChild(tag);
    var sync = function(){ var c = document.querySelector('[data-product] fieldset[data-option]:not([hidden]) input:checked'); tag.textContent = c ? 'Size ' + c.value : ''; };
    document.addEventListener('change', function(e){ if (e.target.closest('fieldset[data-option]')) sync(); }); sync();
  }

  /* 3. FIT VISUALISER: shows where the hem sits on your body */
  var fd = document.querySelector('[data-finder]');
  if (fd) {
    var btn = fd.querySelector('[data-find]'), out = fd.querySelector('[data-out]');
    btn.addEventListener('click', function(){ setTimeout(function(){
      var size = (fd.querySelector('[data-size]') || {}).textContent, h = parseFloat(fd.height && fd.height.value);
      var row = [].slice.call(fd.parentElement.querySelectorAll('[data-chart] tbody tr')).find(function(tr){ return tr.children[0].textContent.trim() === (size || '').trim(); });
      var old = out.querySelector('.fitviz'); if (old) old.remove();
      if (!row || !h) return;
      var lenIn = parseFloat(row.children[2].textContent), lenCm = lenIn * 2.54;
      var shoulder = h * 0.82, hem = shoulder - lenCm, crotch = h * 0.47;
      var where = hem > crotch + 4 ? 'sits at your hip, a cropped streetwear length' : (hem > crotch - 14 ? 'falls over your seat, the intended oversized drape' : 'falls well past your seat, a long, relaxed drop');
      var W = 110, Hpx = 220, k = Hpx / h, y = function(cm){ return (Hpx - cm * k).toFixed(1); };
      var s = parseFloat(y(shoulder));
      var svg = '<svg viewBox="0 0 ' + W + ' ' + Hpx + '" aria-hidden="true">' +
        '<circle cx="55" cy="' + (Hpx - h * .93 * k).toFixed(1) + '" r="' + (h * .06 * k).toFixed(1) + '" fill="none" stroke="#777"/>' +
        '<path d="M38 ' + s + ' L42 ' + y(crotch) + ' L44 ' + Hpx + ' M72 ' + s + ' L68 ' + y(crotch) + ' L66 ' + Hpx + '" fill="none" stroke="#777"/>' +
        '<path d="M28 ' + s + ' L82 ' + s + ' L92 ' + (s + 30) + ' L80 ' + (s + 36) + ' L80 ' + y(hem) + ' L30 ' + y(hem) + ' L30 ' + (s + 36) + ' L18 ' + (s + 30) + ' Z" fill="#fff" opacity=".92"/>' +
        '</svg>';
      var d = document.createElement('div'); d.className = 'fitviz';
      d.innerHTML = svg + '<p>At ' + h + ' cm, size ' + size + ' (' + lenIn + ' in long) ' + where + '.</p>';
      out.insertBefore(d, out.querySelector('[data-use]'));
    }, 0); });
  }

  /* 4. PARALLAX on the giant Devanagari words */
  var px = [].slice.call(document.querySelectorAll('[data-parallax]'));
  if (px.length && !reduce) {
    var tk = false;
    var run = function(){ tk = false; var vh = window.innerHeight; px.forEach(function(el){ var r = el.parentElement.getBoundingClientRect(); var p = (r.top + r.height / 2 - vh / 2) / vh; if (Math.abs(p) > 1.5) return; el.style.transform = 'translate3d(0,' + (p * -70).toFixed(1) + 'px,0)'; }); };
    window.addEventListener('scroll', function(){ if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true }); run();
  }

})();
